import SalesManagementBFJL from './SalesManagementBFJL.vue'
export default SalesManagementBFJL



// WEBPACK FOOTER //
// ./src/pages/salesManagement/bfjl/index.js